import i18n from '@/plugins/vue-i18n';
import { RouteRecordRaw } from 'vue-router';

const { t } = i18n.global;

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      title: t('routes.auth.loginPageTitle'),
      layout: 'auth',
      unguarded: 'Unauthenticated — sign-in page',
    },
  },
  {
    path: '/register/:id?',
    name: 'register',
    component: () => import('@/views/auth/Register.vue'),
    meta: {
      title: t('routes.auth.registerPageTitle'),
      layout: 'auth',
      unguarded: 'Unauthenticated — invite acceptance',
    },
  },
  {
    path: '/account-setup',
    name: 'account-setup',
    component: () => import('@/views/auth/AccountSetup.vue'),
    meta: {
      title: t('routes.auth.accountSetupPageTitle'),
      layout: 'auth',
      unguarded: 'Unauthenticated — completes a new account',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: {
      title: t('routes.auth.forgotPasswordPageTitle'),
      layout: 'auth',
      unguarded: 'Unauthenticated — password reset request',
    },
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: {
      title: t('routes.auth.resetPasswordPageTitle'),
      layout: 'auth',
      unguarded: 'Unauthenticated — password reset',
    },
  },
] as RouteRecordRaw[];
